export default "__VITE_ASSET__COjxxWOe__"